import { Link } from "react-router";
import { Clock } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/i18n/use-translation";

type ComingSoonProps = {
  title: string;
  description: string;
  action?: { label: string; to: string };
};

export function ComingSoon({ title, description, action }: ComingSoonProps) {
  const { t } = useTranslation();
  return (
    <div className="flex h-full flex-col items-center justify-center px-6 py-16 text-center">
      <Clock className="size-10 text-muted-foreground/40" aria-hidden />
      <Badge variant="secondary" className="mt-4">
        {t("common.comingSoon")}
      </Badge>
      <h1 className="mt-3 text-sm font-medium text-foreground">{title}</h1>
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      {action && (
        <Button asChild variant="secondary" size="sm" className="mt-4">
          <Link to={action.to}>{action.label}</Link>
        </Button>
      )}
    </div>
  );
}
